import { FetchApi, DiscoveryApi } from '@backstage/core-plugin-api';
import { buildQueryParams } from './providerUtils';
import { DialogMode } from '../components/Secrets/types';
import { Entity } from '@backstage/catalog-model';

interface ApiData {
  url: string,
  method: string,
  body: any
}

const callApi = async (
  apiData: ApiData,
  fetchApi: FetchApi,
  discoveryApi: DiscoveryApi,
  catalogEntity: Entity,
  secretName: any
): Promise<Response> => {
  const queryParams = buildQueryParams(catalogEntity, secretName);
  const baseUrl = await discoveryApi.getBaseUrl('');

  const response = await fetchApi.fetch(`${baseUrl}${apiData.url}?${queryParams}`, {
    method: apiData.method,
    body: ['GET', 'DELETE'].includes(apiData.method) ? undefined : JSON.stringify(apiData.body),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const executeAction = async (action: DialogMode, secret: any, catalogEntity: Entity, fetchApi: FetchApi, discoveryApi: DiscoveryApi) => {
  const apiData: ApiData = { url: 'ciandtspike-backend-multicloud-secrets/secrets', method: '', body: null };
  let secretName: string | undefined = undefined;
  switch (action) {
    case 'view':
      apiData.method = 'GET';
      secretName = secret.name;
      break
    case 'create':
      apiData.method = 'POST';
      apiData.body = secret;
      break;
    case 'edit':
      apiData.method = 'PUT';
      apiData.body = secret;
      secretName = secret.name;
      break;
    case 'delete':
      apiData.method = 'DELETE';
      secretName = secret.name;
      break;
    case 'list':
      apiData.method = 'GET';
      break;
    default:
      throw new Error(`Unknown action: ${action}`);
  }

  const response = await callApi(apiData, fetchApi, discoveryApi, catalogEntity, secretName);
  
  if(response.status === 204) {
    return await response;
  }

  if(!response.ok && response.status !== 201) {
    throw new Error(`Error on ${action} secret: ${response.statusText}`);
  }

  return await response.json();
}
